import React from 'react';
import PropTypes from 'prop-types';

import { DsTeamIcon } from 'common/react/components/DsTeamIcon';

/**
 * A single team row for the Mobile match card layout: crest + abbreviation + score.
 *
 * @param {object} props - Props.
 * @param {string} props.teamPid - The team's providerId, resolves the DsTeamIcon crest.
 * @param {string} props.teamAbbr - The team's abbreviation, e.g. "RIC".
 * @param {string} [props.score] - The team's score, or "–" when not yet known.
 * @param {string} [props.fallbackIcon] - Fallback crest modifier for placeholder teams.
 * @returns {React.ReactElement} The team row.
 */
export const TeamRow = ({ teamPid, teamAbbr, score, fallbackIcon }) => {
    return (
        <div className="flex w-full min-h-xl items-center gap-2xs pr-s pl-xs transition-opacity duration-s">
            <DsTeamIcon
                className="shrink-0"
                providerId={teamPid}
                theme="notext"
                size="large"
                fallbackIcon={fallbackIcon}
            />
            <span className="grow basis-0 shrink-0 min-w-0 label-l-semi-bold text-on-surface-variant uppercase">
                {teamAbbr}
            </span>
            <span className="label-l-semi-bold text-on-surface-variant">
                {score ?? '–'}
            </span>
        </div>
    );
};

TeamRow.propTypes = {
    teamPid: PropTypes.string.isRequired,
    teamAbbr: PropTypes.string.isRequired,
    score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fallbackIcon: PropTypes.string
};
